<ng-container *notInProductCode="productCode.SGB">
  <fgb-page-header [backButtonLink]="'/'" [pageTitle]="'faq.page.title'" [showQr]="false"></fgb-page-header>

  <div class="container">
    <fgbcl-faq-section></fgbcl-faq-section>
  </div>
</ng-container>

<ng-container *inProductCode="productCode.SGB">
  <fgb-not-found-page></fgb-not-found-page>
</ng-container>
